<template lang="html">

  <div class="ruta-cervantina">

    <section class="banner-intro animation brown full-view-intro -middle column-center" data="ruta-cervantina">

      <h1 class="title -intro">{{$t('vistas.ruta_cervantina')}}</h1>

      <h2 class="subtitle-intro"><router-link :to="$t('enlaces.vive_aldonza')">{{$t('vistas.vive_aldonza')}}</router-link></h2>

    </section>


    
    <section class="new-texto-imagen -first row-center ais animation">

      <router-link :to="$t('enlaces.vive_aldonza')+'#'+$t('banners_experiencia.ruta_cervantina.id')" class="back">{{$t('volver')}}</router-link>

      <div class="textos column-center">
        <h2 class="title">{{$t('banners_experiencia.ruta_cervantina.tradicion.titulo')}}</h2>
        <p>{{$t('banners_experiencia.ruta_cervantina.tradicion.cuerpo')}}</p>
      </div>
      <div class="contenedor-imagen">
        <img src="/static/img/ruta-cervantina/imagen-tradicion.jpg" alt="">
      </div>

    </section>


    <section class="new-texto-imagen -inverse -literatura row-center ais animation">

      <div class="contenedor-imagen">
       <img src="/static/img/ruta-cervantina/imagen-literatura.jpg" alt="">
     </div>

     <div class="textos column-center">
      <p>{{$t('banners_experiencia.ruta_cervantina.literatura.cuerpo')}}</p>
      <a @click="activeText('naturaleza')" class="btn -black">
        <span>{{(naturaleza) ? $t('banners_experiencia.ruta_cervantina.cerrar') : $t('banners_experiencia.ruta_cervantina.leer_mas')}}</span>
      </a>
    </div>

  </section>

  <section class="view-more row-end -naturaleza animation" :show="naturaleza" id="naturaleza">

    <div class="contenedor-textos container row-between ais">
      <div class="left">
        <p v-html="$t('banners_experiencia.ruta_cervantina.naturaleza.more_uno')"></p>
      </div>        
      <div class="right">
        <p v-html="$t('banners_experiencia.ruta_cervantina.naturaleza.more_dos')"></p>
        <p v-html="$t('banners_experiencia.ruta_cervantina.naturaleza.more_tres')"></p>
      </div>
    </div>

  </section>


  <section class="new-texto-imagen row-center ais animation -inverse ">

    <div class="textos column-center">
      <h2 class="title">{{$t('banners_experiencia.ruta_cervantina.naturaleza.titulo')}}</h2>
      <p>{{$t('banners_experiencia.ruta_cervantina.naturaleza.cuerpo')}}</p>
          <a @click="activeText('naturaleza_laguna')" class="btn">
      <span>{{(historia) ? $t('banners_experiencia.ruta_cervantina.cerrar') : $t('banners_experiencia.ruta_cervantina.leer_mas')}}</span>
    </a>          
    </div>
    <div class="contenedor-imagen">
      <img src="/static/img/ruta-cervantina/imagen-naturaleza.jpg" alt="">
    </div>

  </section>

  <section class="view-more row-end -historia animation" :show="naturaleza_laguna" id="naturaleza_laguna">

  <div class="contenedor-textos container row-between ais">

    <div class="container">
      <p v-html="$t('banners_experiencia.ruta_cervantina.naturaleza.more_cuerpo')"></p>
    </div>        

  </div>

</section>




  <section class="new-texto-imagen -historia row-center ais animation">

    <div class="contenedor-imagen">
     <img src="/static/img/ruta-cervantina/imagen-historia.jpg" alt="">
   </div>

   <div class="textos column-center">
    <h2 class="title">{{$t('banners_experiencia.ruta_cervantina.historia.titulo')}}</h2>
    <p v-html="$t('banners_experiencia.ruta_cervantina.historia.cuerpo')"></p>
    <a @click="activeText('historia')" class="btn -black">
      <span>{{(historia) ? $t('banners_experiencia.ruta_cervantina.cerrar') : $t('banners_experiencia.ruta_cervantina.leer_mas')}}</span>
    </a>
  </div>

</section>

<section class="view-more row-end -historia animation" :show="historia" id="historia">

  <div class="contenedor-textos container row-between ais">

    <div class="left">
      <p v-html="$t('banners_experiencia.ruta_cervantina.historia.more_uno')"></p>
    </div>        
    <div class="right">
      <p v-html="$t('banners_experiencia.ruta_cervantina.historia.more_dos')"></p>
    </div>

  </div>

</section>

<section class="new-texto-imagen row-center ais animation">

  <div class="textos column-center">
    <h2 class="title">
      {{$t('banners_experiencia.ruta_cervantina.legado.titulo')}}
    </h2>
    <p>{{$t('banners_experiencia.ruta_cervantina.legado.cuerpo')}}</p>
    <a href="https://blog.aldonzagourmet.com/2019/02/don-quijote-cava-aldonza/" target="_blank" class="btn">
      <span>{{$t('banners_experiencia.ruta_cervantina.legado.boton')}}</span>
    </a>
  </div>
  <div class="contenedor-imagen">
    <img src="/static/img/ruta-cervantina/imagen-legado.jpg" alt="">
  </div>

</section>



<div class="contenedor-otras-experiencias animation">
  <otras-experiencias></otras-experiencias>
</div>


</div>

</template>

<script lang="js">

  import otrasExperiencias from '@/components/parts/otras-experiencias';

  export default  {
    name: 'ruta-cervantina',
    data(){
      return {
        naturaleza : false,
        naturaleza_laguna : false,
        historia : false
      }
    },
    methods : {
      activeText : function(el){
        this[el] = !this[el];
        if(this[el]){
          $('html, body').animate({
            scrollTop: $("#"+el).position().top
          }, 1000);
        }
      } 
    },
    components : {
      'otras-experiencias' : otrasExperiencias
    }
  }
</script>

<style scoped lang="scss">

  .full-view-intro[data=ruta-cervantina]{
    background: url("/static/img/ruta-cervantina/background-intro-ruta-cervantina.jpg") center/cover no-repeat;
    /*background-attachment: fixed;*/
  }

  .container{
    max-width: 1330px;
  }

  .title.-intro{
    overflow: visible;
    height: auto;
  }
  
  .textos{
    .btn{
      margin-top: 30px;
    }
  }
  
  .show-more{
    font-size: 40px;
  }

  .intro-experiencias{
    p{
      text-align: center;
    }
    .title{
      margin-top: 20px;
      text-align: center;
    }
  }

  .new-texto-imagen.-literatura{
    background: white;
    color: black;
    &::before{
      position:absolute;
      right: 0;
      bottom: 0;
      width: 180px;
      height: 420px;
      display: inline-block;
      content: '';
      background: url("/static/img/caballero-oscuro.png") center/150px no-repeat;
      opacity: .2;
    }

    .title{
      color: #000;
    }
  }

  .new-texto-imagen.-historia{
    background: white;
    color: black;

    .title{
      color: #000;
    }
  }



</style>



// WEBPACK FOOTER //
// src/components/views/experiencias/ruta-cervantina.vue